module.exports = __webpack_public_path__ + "images/2730cabf4a18987ca6e23ae1f1de0900-cayman.jpg";